let elements = [];

export function $(selector, context = document) {
    const el = context.querySelector(selector);
    elements.push(el);
    return el;
}

export function $$(selector, context = document) {
    const els = context.querySelectorAll(selector);
    for (let i = 0; i < els.length; i++) {
        elements.push(els[i]);
    }
    return els;
}

export function clearElementRefs() {
    elements = [];
}



// WEBPACK FOOTER //
// ./assets/js/components/_queryselector.js